var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustrationLogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 145,
    viewBox: "0 0 148 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6031_733)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.08 125.92C116.181 125.92 125.18 116.921 125.18 105.82C125.18 94.7193 116.181 85.7202 105.08 85.7202C93.9791 85.7202 84.98 94.7193 84.98 105.82C84.98 116.921 93.9791 125.92 105.08 125.92Z",
    fill: "#FF009D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2799 103.85C57.6651 103.85 73.3799 88.1356 73.3799 68.7504C73.3799 49.3652 57.6651 33.6504 38.2799 33.6504C18.8947 33.6504 3.17993 49.3652 3.17993 68.7504C3.17993 88.1356 18.8947 103.85 38.2799 103.85Z",
    fill: "#00A5D5"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94.52 96.4804C114.706 96.4804 131.07 80.1164 131.07 59.9304C131.07 39.7444 114.706 23.3804 94.52 23.3804C74.334 23.3804 57.97 39.7444 57.97 59.9304C57.97 80.1164 74.334 96.4804 94.52 96.4804Z",
    fill: "#FFDF00"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5099 11.0802C114.7 -3.72984 146.93 12.0802 146.93 12.0802V131.27C146.93 131.27 114.7 116.45 74.5099 131.27C34.3199 116.46 0.929932 131.27 0.929932 131.27V12.0802C0.929932 12.0802 34.3299 -3.72984 74.5099 11.0802Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9299 0.140137V144.86",
    stroke: "black",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6031_733"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 147,
    height: 144.72,
    fill: "white",
    transform: "translate(0.429932 0.140137)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationLogo1);
export default __webpack_public_path__ + "static/media/illustration-logo-1.face3b303f06168bf42eed566f48951e.svg";
export { ForwardRef as ReactComponent };